import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import "../../App.css";
import "./Homepage.css";
import AboutHelper from "../../components/AboutHelper/AboutHelper";
import TellAboutUsHelper from "../../components/TellAboutUsHelper/TellAboutUsHelper";
import ContactUsHelper from "../../components/ContactUsHelper/ContactUsHelper";
import homepagevideo from "../../videos/homepagevideo.mp4";
import HeaderHomepage from "./../../components/HeaderHomepage/HeaderHomepage";
import Footer from "./../../components/Footer/Footer";
import QandA from "../../components/Q&A/Q&A";
import StoryTelling from "../../components/StoryTelling/StoryTelling";
import Bi from "../../components/BI/Bi";

const Homepage = () => {
  let history = useHistory();

  const logInClicked = async () => {
    history.push("/login");
  };

  const signUpClicked = () => {
    history.push("/signup");
  };

  return (
    <div className="full-screen-homepage">
      {" "}
      {/*&& chk === '/Questionnaires' } */}{" "}
      <div className="">
        <HeaderHomepage />
        <form
          className="homepage-form"
          onClick={() => {
            if (document.getElementById("slidepanel").style.width === "200px") {
              document.getElementById("slidepanel").style.width = "0px";
            }
          }}
        >
          <section className="homepage-section homepage-hero">
            <div className="homepage-hero-content">
              <div className="homepage-gift-badge homepage-trust-badge">
                ✨ אלפי משתמשים כבר כאן • מאות דייטים • חודש מתנה למצטרפים חדשים
              </div>

              <h1 className="homepage-hero-title">
                היכרויות רציניות,
                <span>בלי לגלול בין מאות פרופילים</span>
              </h1>

              <p className="homepage-hero-description">
                דאבל הוא אתר היכרויות ששולח לך התאמות אישיות וממוקדות בעזרת
                אלגוריתם חכם, תוך שמירה על הפרטיות שלך.
              </p>

              <div className="homepage-hero-audience">
                מתאים לדתיים, חרדים, דתל״שים, מסורתיים וחילונים
              </div>

              <button
                type="button"
                className="homepage-primary-button"
                onClick={signUpClicked}
              >
                להרשמה חינם
              </button>

              <div className="homepage-hero-slogan">
                תנסו, מקסימום תינשאו ❤️
              </div>
            </div>

            <div className="homepage-hero-media">
              <video autoPlay loop muted playsInline>
                <source src={homepagevideo} type="video/mp4" />
                הדפדפן שלך לא תומך בווידאו.
              </video>
            </div>
          </section>

          <section className="homepage-section homepage-about-section">
            <div className="homepage-section-heading">
              <span>החזון שלנו</span>

              <h2>למה בנינו את דאבל?</h2>

              <p>כדי להפוך את עולם ההיכרויות לממוקד, מכבד, פרטי ואישי יותר.</p>
            </div>

            <StoryTelling />
          </section>

          <section className="homepage-section homepage-about-section">
            <div className="homepage-section-heading">
              <span>אפשר גם עם ליווי אישי</span>

              <h2>הכירו את הדאבליסטים</h2>

              <p>
                <strong>רוב המשתמשים בדאבל נרשמים באופן עצמאי.</strong> דאבליסט
                הוא אפשרות נוספת למי שמעוניין בליווי, ייעוץ ונקודת מבט נוספת
                בדרך לזוגיות.
              </p>
            </div>

            <div className="homepage-about-goals">
              <div className="homepage-about-goal">
                <h3>לא חובה דאבליסט</h3>

                <p>
                  אפשר להירשם לדאבל ולהשתמש באתר באופן עצמאי. הדאבליסט הוא
                  אפשרות נוספת למי שרוצה שמישהו ילווה אותו בתהליך.
                </p>
              </div>

              <div className="homepage-about-goal">
                <h3>מי יכול להיות דאבליסט?</h3>

                <p>
                  חבר, בן משפחה, שדכן, מאמן לזוגיות או כל אדם שמכיר אתכם ורוצה
                  ללוות אתכם בדרך לזוגיות.
                </p>
              </div>

              <div className="homepage-about-goal">
                <h3>מה הדאבליסט עושה?</h3>

                <p>
                  הדאבליסט יכול לרשום מועמד לאתר, ללוות אותו לאורך הדרך, לעזור
                  בהתלבטויות ולעבור יחד איתו על ההתאמות במסך ייעודי עבורו.
                </p>
              </div>
            </div>

            <button
              type="button"
              className="homepage-primary-button"
              onClick={signUpClicked}
            >
              להצטרפות לדאבל
            </button>
          </section>

          <section className="homepage-section homepage-about-section">
            <div className="homepage-section-heading">
              <span>הדייט כבר נקבע?</span>

              <h2>עכשיו רק נשאר לבחור מקום ❤️</h2>

              <p>
                בדאבל מחכה לכם מאגר של מקומות ורעיונות לדייטים בכל רחבי הארץ.
                בוחרים מה מתאים לכם – ואנחנו עוזרים למצוא.
              </p>
            </div>

            <div className="homepage-about-goals">
              <div className="homepage-about-goal">
                <h3>📍 לפי אזור</h3>
                <p>צפון, דרום, מרכז או ירושלים – חפשו מקום שמתאים לכם.</p>
              </div>

              <div className="homepage-about-goal">
                <h3>❤️ לפי סוג הדייט</h3>
                <p>טבע, אוכל, פעילות או אקסטרים – וגם לפי השלב בקשר.</p>
              </div>

              <div className="homepage-about-goal">
                <h3>✨ גם בחינם</h3>
                <p>אפשר לסנן ולמצוא גם רעיונות ומקומות שלא דורשים תשלום.</p>
              </div>
            </div>

            <button
              type="button"
              className="homepage-primary-button"
              onClick={() => history.push("/findplace")}
            >
              למצוא מקום לדייט
            </button>
          </section>

          <section className="homepage-section homepage-about-section">
            <div className="homepage-section-heading">
              <span>סיפורים אמיתיים</span>

              <h2>כותבים לנו</h2>

              <p>הודעות שקיבלנו ממשתמשים ומזוגות שהכירו דרך דאבל.</p>
            </div>

            <TellAboutUsHelper />
          </section>

          <section className="homepage-section homepage-about-section">
            <div className="homepage-section-heading">
              <span>דאבל במספרים</span>

              <h2>מי נמצא בדאבל?</h2>

              <p>הכירו את קהילת המשתמשים שלנו לפי גיל, סגנון דתי וסטטוס.</p>
            </div>

            <Bi />
          </section>
          <section className="homepage-section homepage-about-section">
            <div className="homepage-section-heading">
              <span>נשארים בקשר</span>

              <h2>יש לכם שאלה?</h2>

              <p>
                טיפים לדייטים, סיפורי הצלחה, עדכונים ופיצ׳רים חדשים – מוזמנים
                לעקוב ולהישאר בקשר.
              </p>
            </div>

            <div
              className="lbl"
              style={{
                marginTop: "22px",
                marginBottom: "4px",
                fontWeight: "600",
              }}
            >
              עקבו אחרינו
            </div>

            <div
              className="contactUsHelper faceline"
              style={{
                justifyContent: "center",
                gap: "28px",
                margin: "18px auto 26px",
              }}
            >
              <a
                href="https://www.facebook.com/%D7%93%D7%90%D7%91%D7%9C-%D7%94%D7%9B%D7%A8%D7%95%D7%99%D7%95%D7%AA-103072662171430"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="פייסבוק של דאבל"
              >
                <div
                  className="facebook"
                  style={{ height: "30px", width: "32px" }}
                ></div>
              </a>

              <a
                href="https://instagram.com/double2love.ai?igshid=MzNlNGNkZWQ4Mg=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="אינסטגרם של דאבל"
              >
                <div
                  className="instegramrealicon"
                  style={{ height: "30px", width: "32px" }}
                ></div>
              </a>

              <a
                href="https://wa.me/972549624084"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="וואטסאפ של דאבל"
              >
                <div
                  className="whatsupp"
                  style={{ height: "32px", width: "32px" }}
                ></div>
              </a>

              <a
                href="mailto:doublelo2love@gmail.com"
                aria-label="שליחת מייל לדאבל"
              >
                <div
                  className="gmail"
                  style={{ height: "24px", width: "32px" }}
                ></div>
              </a>
            </div>

            <button
              type="button"
              className="signup-homepage"
              style={{
                width: "250px",
                height: "44px",
                lineHeight: "44px",
                padding: "0",
                margin: "8px auto 34px",
                animation: "none",
                textShadow: "none",
              }}
              onClick={signUpClicked}
            >
              להרשמה וקבלת חודש מתנה
            </button>

            <div
              style={{
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                paddingTop: "24px",
                marginTop: "6px",
              }}
            >
              <div className="lbl" style={{ marginBottom: "12px" }}>
                סיוע וייעוץ
              </div>

              <div
                className="faceline"
                style={{
                  justifyContent: "center",
                  gap: "16px",
                }}
              >
                <div className="mati" aria-label="מטי"></div>
                <div className="maof" aria-label="קרן מעוף"></div>
                <div className="aspire" aria-label="אספייר עזריאלי"></div>
              </div>
            </div>

            <div
              style={{
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                paddingTop: "22px",
                marginTop: "22px",
              }}
            >
              <div className="lbl" style={{ marginBottom: "12px" }}>
                שיתופי פעולה
              </div>

              <div
                className="faceline"
                style={{
                  justifyContent: "center",
                  gap: "16px",
                }}
              >
                <div className="taciru" aria-label="תכירו"></div>
                <div className="goodvibes" aria-label="באים בטוב"></div>
              </div>
            </div>

            <div
              style={{
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                paddingTop: "22px",
                marginTop: "22px",
              }}
            >
              <div
                className="faceline"
                style={{
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <div className="co"></div>
                <div className="lbl">כל הזכויות שמורות לדאבל</div>
              </div>

              <div
                className="faceline"
                style={{
                  justifyContent: "center",
                  gap: "16px",
                  marginTop: "10px",
                  fontSize: "14px",
                }}
              >
                <Link to="/terms" className="homepage-footer-link">
                  תקנון האתר
                </Link>
              </div>
            </div>
          </section>
        </form>{" "}
      </div>
    </div>
  );
};

export default Homepage;
